import request from '../../utils/request';

export async function getAdminUserListRequest(params) {
  return request({
    url: 'admin/user/list',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function getAdminUserBaseListRequest(params) {
  return request({
    url: 'admin/user/base/list',
    method: 'get',
    headers: 'json',
    params,
  });
}

export async function addAdminUserRequest(params) {
  return request({
    url: 'admin/user/add',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function updateAdminUserRequest(params) {
  return request({
    url: 'admin/user/update',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function updateAdminUserStatusRequest(params) {
  return request({
    url: 'admin/user/update/status',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function getAdminRoleListRequest(params) {
  return request({
    url: 'admin/user/role/list',
    method: 'get',
    headers: 'json',
    params,
  });
}

export async function addAdminRoleRequest(params) {
  return request({
    url: 'admin/user/role/add',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function updateAdminRoleRequest(params) {
  return request({
    url: 'admin/user/role/update',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function deleteAdminRoleRequest(params) {
  return request({
    url: 'admin/user/role/delete',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function getAdminRolePermissionListRequest(params) {
  return request({
    url: 'admin/user/role/permission/list',
    method: 'get',
    headers: 'json',
    params,
  });
}
